module.exports = __webpack_public_path__ + "img/esma_logo.22989712.svg";